import { SVGProps, useId } from "react";

export default function PostPresentationSlidesIcon(
  props: SVGProps<SVGSVGElement>,
) {
  const { height = 20, width = 20, ...rest } = props;
  const id = useId();
  const bodyGradientId = `post_presentation_slides_body_${id}`;
  const headerGradientId = `post_presentation_slides_header_${id}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17.2589 6.76689V14.6086C17.2589 16.6586 15.5839 18.3336 13.5339 18.3336H6.46719C4.41719 18.3336 2.74219 16.6586 2.74219 14.6086V6.76689C2.74219 5.34189 3.54219 4.10023 4.71719 3.47523C5.12552 3.25856 5.63385 3.55023 5.63385 4.01689C5.63385 5.34189 6.71719 6.42523 8.04219 6.42523H11.9589C13.2839 6.42523 14.3672 5.34189 14.3672 4.01689C14.3672 3.55023 14.8672 3.25856 15.2839 3.47523C16.4589 4.10023 17.2589 5.34189 17.2589 6.76689Z"
        fill={`url(#${bodyGradientId})`}
      />
      <path
        d="M11.9604 1.66699H8.04375C7.17708 1.66699 6.46875 2.36699 6.46875 3.23366V4.01699C6.46875 4.88366 7.16875 5.58366 8.03542 5.58366H11.9604C12.8271 5.58366 13.5271 4.88366 13.5271 4.01699V3.23366C13.5354 2.36699 12.8271 1.66699 11.9604 1.66699Z"
        fill={`url(#${headerGradientId})`}
      />
      <defs>
        <linearGradient
          id={bodyGradientId}
          x1="10.0005"
          y1="3.40234"
          x2="10.0005"
          y2="18.3336"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={headerGradientId}
          x1="9.99795"
          y1="1.66699"
          x2="9.99795"
          y2="5.58366"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}
